import http from './http'

export function loginApi(username, password) {
  return http.post('/auth/login', { username, password })
}

export function fetchMeApi() {
  return http.get('/user/me')
}
